import React from 'react';

import {Stack} from '@mui/material';
import {useNavigate} from 'react-router';

import {
  Head,
  MonitorMap,
  GoogleMapProvider,
  MonitorMapProvider,
  RadarCard,
  RightDrawer,
  WeatherCard,
} from '@wheeebo/polaris-ui';

import {config} from '@components/Constants';
import VehicleListCard from '@components/pages/monitor/VehicleListCard';

function MonitorPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <GoogleMapProvider>
      <MonitorMapProvider>
        <Head title="Monitor" />
        <MonitorMap apiKey={config.GOOGLE_MAP_API_KEY || ''} on3dSelected={() => navigate('/monitor3d')} />
        <RightDrawer>
          <Stack gap={1 / 2}>
            <WeatherCard />
            <RadarCard />
            <VehicleListCard />
          </Stack>
        </RightDrawer>
      </MonitorMapProvider>
    </GoogleMapProvider>
  );
}

export default React.memo(MonitorPage);
